import authService from "src/helpers/authService";
import { User } from "src/store/User";

export function hasSomeRoutePermission() : boolean {
  return authService(User.value.roles, "registrar", "webmaster", "gameScheduler")
}
